module.exports = __webpack_public_path__ + "img/injury_rehab_icon.be94a061.svg";